import React from 'react'

export const Divider: React.FC = () => <hr className='my-4 w-full border-gray-800 dark:border-white' />
